module.exports = "<mat-card>\r\n  <mat-card-content>\r\n    <h3>Authenticating, please wait</h3>\r\n  </mat-card-content>\r\n</mat-card>\r\n"